if (!customElements.get('navarambh-opening')) {
  customElements.define('navarambh-opening', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }

    init() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const items = this.querySelectorAll('.nvo-reveal');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0.08 });
        this.classList.add('is-ready');
        items.forEach(item => this.observer.observe(item));
      }
      this.update = () => {
        this.frame = null;
        const rect = this.getBoundingClientRect();
        const progress = this.motion.matches || innerWidth < 1160 || innerHeight < 700
          ? 0 : Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
        this.style.setProperty('--nvo-drift', progress.toFixed(3));
      };
      this.schedule = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(this.update);
      };
      this.frame = null;
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.motion.addEventListener('change', this.schedule);
      this.update();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.motion?.removeEventListener('change', this.schedule);
    }
  });
}